import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent } from './core/sidebar/sidebar.component';
import { EventBusService, EventCallback } from './event-bus.service';
import { ToastModule } from 'primeng/toast';
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { LoadingIndicatorComponent } from "./shared/loading-indicator/loading-indicator.component";
import { getCurrentUser } from 'aws-amplify/auth';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, SidebarComponent, ToastModule],
  providers: [DialogService],
  template: `
    <p-toast position="bottom-center"></p-toast>
    <ng-container #container *ngIf="user">
      <sidebar></sidebar>
    </ng-container>
    <router-outlet></router-outlet>
  `,
  styleUrl: './app.component.scss'
})


export class AppComponent implements OnInit, OnDestroy {
  title = 'hero-portal';
  user: string | null;

  private loginSubscription: EventCallback;
  private logoutSubscription: EventCallback;
  private showHideLoadingIndicator: EventCallback;
  private loadingIndicatorDialogRef: DynamicDialogRef<LoadingIndicatorComponent>

  @ViewChild('container') container: ElementRef
  constructor(private eventBusService: EventBusService,
    private dialogService: DialogService) { }

  async ngOnInit() {
    document.documentElement.lang = 'ar-EG';
    document.documentElement.dir = 'ltr';
    try {
      this.user = (await getCurrentUser()).username;
    } catch { }

    this.loginSubscription = (user: string) => {
      this.user = user;
    };

    this.logoutSubscription = () => {
      this.user = null;
    };

    this.showHideLoadingIndicator = (data) => {
      // This is a little suspect. There is no way to dynamically determine if the loading indicator is already showing.
      // Due to the nature of the ajax alls (potentially multiple active at any given time) we need to track the number
      // of requests active at any given time. The loading service tracks outbound ajax requests by incrementing a
      // counter (activeRequestCount). It also decrements the counter as ajax requests complete.
      // In theory, multiple open and close eventTypes can be generated. However, it is only necessary to open or close
      // the dialog when the activeRequestCount is 1 or 0, respectively.
      if (data['activeRequestCount'] === 1 && data['eventType'] === 'open') {
        this.loadingIndicatorDialogRef = this.dialogService.open(LoadingIndicatorComponent, {
          showHeader: false,
          modal: true,
          closable: false,
          draggable: false,
          styleClass: 'loading-indicator-dialog',
        })
      } else if (this.loadingIndicatorDialogRef && data['activeRequestCount'] === 0 && data['eventType'] === 'close') {
        this.loadingIndicatorDialogRef.close()
      }
    };

    this.eventBusService.subscribe('user:login', this.loginSubscription);
    this.eventBusService.subscribe('user:logout', this.logoutSubscription);
    this.eventBusService.subscribe('api:loadingIndicator', this.showHideLoadingIndicator);
  }

  ngOnDestroy() {
    this.eventBusService.unsubscribe('user:login', this.loginSubscription);
    this.eventBusService.unsubscribe('user:logout', this.logoutSubscription);
    this.eventBusService.unsubscribe('api:loadingIndicator', this.showHideLoadingIndicator)
  }
}
